import { desktopRadius } from '~/actions/extraHTML/wheelOfFortune/const';

export const wheelDesktopStyles = (iterator: number, prefix: string) => `
.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}desktop_wheel_filler {
  position: absolute;
  top: 0;
  left: -${desktopRadius}px;
}

.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}wheel_notification_desktop {
  position: absolute;
  top: 0;
  left: 0;
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop {
  position: relative;
}

.${prefix}notification_with_wheel_desktop_${iterator}.${prefix}adaptation__box__extraHTML {
  transform: scale(.75) !important;
  left: 0% !important;
  top: 10% !important;
}
`;
